<!-- <app-navbar [showSearchBar]="true"></app-navbar> -->
<router-outlet></router-outlet>
<!-- <app-footer></app-footer> -->
